<template>
  <v-text-field
    v-model="modelValue"
    v-bind="$attrs"
    v-on="$listeners"
    v-validate="validations"
    :error-messages="errorMessages"
    :hide-details="errorMessages.length === 0"
    :data-vv-as="displayName"
    :data-vv-name="inputIdentifier"
    :id="`input_${inputIdentifier}`"
    :label="`${displayName}${validations.required ? ' *' : ''}`"
    :name="inputIdentifier"
    class="text-input-common"
    outline/>
</template>

<script>
import InputCommonMixin from '@/mixins/InputCommonMixin';

export default {
  mixins: [InputCommonMixin],
};
</script>

<style lang="scss" scoped>
.text-input-common {
  background: white;
}
</style>
